export default __webpack_public_path__ + "static/media/Rectangle153@2x.f5c7fe71.png";